// NAVIGATION TYPES
export interface NavItem {
  label: string;
  path?: string;
  icon?: string;
  children?: { label: string; path: string }[];
}

// NAVIGATION ITEMS
export const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/Admin/Dashboard', icon: 'dashboard' },
  {
    label: 'Users',
    icon: 'users',
    children: [
      { label: 'Players', path: '/Admin/Users/Players' },
      { label: 'Administrators', path: '/Admin/Users/Administrators' },
    ],
  },
  { label: 'Logout', path: '/Logout', icon: 'logout' },
];